import React from "react";
import { Box } from "@mui/material";
import LevelDevice from "./Devices/LevelDevice";
import parseNumber from "../../../../utils/parseCalculate";
import { useLiveDevice } from "../../../../hooks/useLiveDeviceData";
import { formatLevelTransmitterDashboardDateTime } from "../../../../utils/levelTransmitterDateTime";

const transmitterFillPercent = (value, unit) => {
  if (value == null || value === "") return null;
  const reading = Number(value);
  if (!Number.isFinite(reading)) return null;
  const normalizedUnit = String(unit || "m").trim().toLowerCase();
  const fullScale = normalizedUnit === "cm" ? 500 :
    ["ft", "foot", "feet"].includes(normalizedUnit) ? 5 * 3.280839895013123 : 5;
  return Math.round(Math.max(0, Math.min(100, reading / fullScale * 100)));
};

function Item(props) {
  const { sx, ...other } = props;
  return <Box {...other} />;
}

const TankContainer = (props) => {
  const { data, units, status } = useLiveDevice(
    props.isExpired ? null : props.deviceId,
    { watchStatus: true }
  );
  const deviceStatus = props.isExpired ? "inactive" : status;
  const levelValue = data ? parseNumber(data.level) : "--";
  const levelUnit = units.level_unit || props.levelUnit || "m";

  return (
    <Item>
      <LevelDevice
        deviceStatus={deviceStatus}
        powerStatus={data?.battery == null ? null : Number(data.battery)}
        deviceId={props.deviceId}
        lastUpdated={
          props.isExpired ? "" : data?.date_time
            ? props.deviceType === "level_transmitter"
              ? formatLevelTransmitterDashboardDateTime(data.date_time)
              : `${new Date(data.date_time).toLocaleDateString("en-GB")} ${new Date(data.date_time).toLocaleTimeString("en-US", { hour12: true })}`
            : "--"
        }
        levelValue={
          props.isExpired
            ? "Subscription Expired"
            : `${levelValue} ${levelUnit}`
        }
        title={props.name}
        deviceType={props.deviceType}
        fillPercent={props.isExpired || !data ? null : transmitterFillPercent(data.level, levelUnit)}
      />
    </Item>
  );
};

export default TankContainer;
